(() => {
  if (customElements.get('wf-glow-set-cta')) return;
  customElements.define('wf-glow-set-cta', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.wfGlowReady) return;
        this.control = this.querySelector('.wf-glow-motion');
        this.poster = this.querySelector('.wf-glow-poster');
        if (!this.control || !this.poster || !this.dataset.motionSrc) return;
        this.wfGlowReady = true;
        this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onClick = () => this.setPlaying(this.dataset.playing !== 'true');
        this.onPreference = () => {
          this.setPlaying(false);
          this.control.disabled = this.preference.matches;
          this.control.textContent = this.preference.matches ? 'Animation off (reduced motion)' : 'Play animation';
        };
        this.control.addEventListener('click', this.onClick);
        this.preference.addEventListener('change', this.onPreference);
        this.control.hidden = false;
        this.onPreference();
        if (!this.preference.matches) this.setPlaying(true);
      });
    }
    setPlaying(requested) {
      const playing = requested && !this.preference.matches;
      this.dataset.playing = String(playing);
      this.control.setAttribute('aria-pressed', String(playing));
      this.control.textContent = playing ? 'Stop animation' : 'Play animation';
      if (playing) {
        const animated = document.createElement('img');
        animated.className = 'wf-glow-animation';
        animated.alt = '';
        animated.width = this.poster.width;
        animated.height = this.poster.height;
        animated.hidden = true;
        animated.onload = () => {
          if (this.dataset.playing === 'true' && this.animation === animated) {
            animated.hidden = false;
            this.poster.hidden = true;
          }
        };
        animated.onerror = () => { animated.remove(); this.poster.hidden = false; };
        this.animation = animated;
        this.poster.parentElement.append(animated);
        animated.src = this.dataset.motionSrc;
      } else {
        if (this.animation) {
          this.animation.onload = null;
          this.animation.onerror = null;
          this.animation.removeAttribute('src');
          this.animation.remove();
          this.animation = null;
        }
        this.poster.hidden = false;
      }
    }
    disconnectedCallback() {
      if (!this.wfGlowReady) return;
      this.setPlaying(false);
      this.control.removeEventListener('click', this.onClick);
      this.preference.removeEventListener('change', this.onPreference);
      this.wfGlowReady = false;
    }
  });
})();
